<template>
  <div 
    class="offer-summary-card p-3 mb-4 rounded shadow-sm"
    :class="{'offer-rejected': rejected}"
  >
    <h6 class="summary-title mb-3">
      <i class="fa fa-calculator mr-2"></i>
      {{ $t('detailedComparisonModal.offerSummary') || 'Təklif Xülasəsi' }}
    </h6>

    <div class="row">
      <div class="col-md-4 mb-3">
        <div class="summary-item p-3 rounded">
          <div class="summary-label mb-1">
            {{ $t('detailedComparisonModal.yekunQiymet') }}
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="summary-value">
              {{ mainTotal }} <small>AZN</small>
            </div>
            <div 
              class="rank-badge"
              :class="{
                'rank-1': mainRank === 1,
                'rank-other': mainRank !== 1
              }"
            >
              {{ mainRank }}-ci
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="summary-item p-3 rounded">
          <div class="summary-label mb-1">
            {{ $t('detailedComparisonModal.alternativYekunQiymet') }}
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="summary-value">
              {{ alternativeTotal }} <small>AZN</small>
            </div>
            <div 
              class="rank-badge"
              :class="{
                'rank-1': alternativeRank === 1,
                'rank-other': alternativeRank !== 1
              }"
            >
              {{ alternativeRank }}-ci
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="summary-item selected-summary p-3 rounded">
          <div class="summary-label mb-1">
            {{ $t('detailedComparisonModal.selectedYekunQiymet') }}
          </div>
          <div class="summary-value">
            {{ selectedTotal }} <small>AZN</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferTotalsSection",
  props: {
    mainTotal: {
      type: [Number, String],
      required: true
    },
    mainRank: {
      type: Number,
      required: true
    },
    alternativeTotal: {
      type: [Number, String],
      required: true
    },
    alternativeRank: {
      type: Number,
      required: true
    },
    selectedTotal: {
      type: [Number, String],
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
/* Summary Section */
.offer-summary-card {
  background-color: #f8f9fa;
  border-left: 4px solid #28a745;
}

.summary-title {
  color: #495057;
  font-weight: 600;
}

.summary-item {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.summary-item:hover {
  background-color: #f8f9fa;
}

.selected-summary {
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.summary-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
}

.summary-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #343a40;
}

.rank-badge {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #6c757d;
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rank-1 {
  background-color: #28a745;
}

.offer-rejected {
  background-color: #f9f9f9;
  opacity: 0.75;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .summary-item {
    margin-bottom: 1rem;
  }
}
</style>